<template>
  <button class="button">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'Submit'
}
</script>

<style lang="scss">
  .button {
    padding: 7px 5px 8px 3px;
    background: none;
    border: 1px solid #ebedf2;
    border-radius: 3px;
    font-size: 14px;
    line-height: 21px;
    font-weight: 400;
    color: #333333;
    text-align: center;
    box-sizing: border-box;

    &:disabled {
      opacity: 0.7;
    }

    &:focus {
      outline: 0;
    }
  }
</style>
